import useTranslation from '../useTranslation';

import useMultiSelectField from 'hooks/useMultiSelectField';

import type { FieldValues, Props } from './types';

const useData = <T extends FieldValues>({
    control,
    isOpen,
    isRequired = false,
    name,
    onPanelClose,
    onPanelOpen,
    ref
}: Props<T>) => {
    const { PILOTS_ARE_REQUIRED } = useTranslation();

    return useMultiSelectField({
        control,
        isOpen,
        isRequired,
        name,
        onPanelClose,
        onPanelOpen,
        ref,
        requiredMessage: isRequired ? PILOTS_ARE_REQUIRED : false
    });
};

export default useData;
